import ActionButton from "./ActionButton";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import {Link} from "react-router-dom";
import Badge from "../../components/Badge";
import Avatar from "react-avatar";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";
import CouponStockModal from "./CouponStockModal";

function Coupon({coupon}) {
    const [couponDetailsModal, setCouponDetailsModal] = useState(false);
    const [expandedProductsSupported, setExpandedProductsSupported] = useState(false);

    const toggleExpansionProductsSupported = () => {
        setExpandedProductsSupported(!expandedProductsSupported);
    };

    const [expandedCustomersSupported, setExpandedCustomersSupported] = useState(false);

    const toggleExpansionCustomersSupported = () => {
        setExpandedCustomersSupported(!expandedCustomersSupported);
    };
    const couponDetailsModalToggle = () => setCouponDetailsModal(!couponDetailsModal);

    const [stockHistoryModal, setStockHistoryModal] = useState(false);
    const stockHistoryModaltoggle = () => setStockHistoryModal(!stockHistoryModal);

    return (
        <>
            <tr className="text-center">
                <td onClick={couponDetailsModalToggle}>
                    <Link className="text-primary">{coupon.code}</Link>
                </td>
                <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        {coupon.eligible_products.length === 0 ? (
                            <span>All Products</span>
                        ) : (
                            <>
                                {coupon.eligible_products.slice(0, 3).map(products => (
                                    <Avatar size={30} name={products} round />
                                ))}
                                {coupon.eligible_products.length > 3 && (
                                    <span
                                        onClick={() => {
                                            couponDetailsModalToggle();
                                            toggleExpansionProductsSupported();
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                    <div
                                    style={{
                                        width: '35px',
                                        height: '35px',
                                        backgroundColor: 'grey',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: 'white',
                                        fontSize: '12px',
                                    }}
                                >
                                  {coupon.eligible_products.length > 3? `+${coupon.eligible_products.length - 3}` : "-"}
                                </div>
                                    </span>
                        )}
                            </>
                        )}
                    </div>
                </td>
                <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        {coupon.eligible_customers.length === 0 ? (
                            <span>All Customers</span>
                        ) : (
                            <>
                            {coupon.eligible_customers.slice(0, 3).map(customers => (
                                <Avatar key={customers} size={30} name={customers} round />
                            ))}
                            {coupon.eligible_customers.length > 3 && (
                                <span
                                    onClick={() => {
                                        couponDetailsModalToggle();
                                        toggleExpansionCustomersSupported();
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                            <div
                            style={{
                                width: '35px',
                                height: '35px',
                                backgroundColor: 'grey',
                                borderRadius: '50%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: 'white',
                                fontSize: '12px',
                            }}
                        >
                          {coupon.eligible_customers.length > 3? `+${coupon.eligible_customers.length - 3}` : "-"}
                            </div>
                        </span>
                            )}
                            </>
                        )}
                    </div>
                </td>
                <td>{coupon.value === null ? "-" : coupon.value}</td>
                <td>
                    {coupon.percentage !== null
                        ? `${parseFloat(coupon.percentage) % 1 === 0 ? parseInt(coupon.percentage) : coupon.percentage}%`
                        : "-"
                    }
                </td>
                <td>{coupon.type}</td>
                <td><Badge badge={
                    coupon.status === "ACTIVE"
                        ? "badge badge-light-success"
                        : "badge badge-light-danger"
                } status={coupon.status}/></td>
                {/*<td>*/}
                {/*    {coupon.expiration_date == null*/}
                {/*        ? 'No Expiry'*/}
                {/*        : new Date(coupon.expiration_date).toLocaleString([], DateTimeOptionsMediumShort)*/}
                {/*    }*/}
                {/*</td>*/}
                <td>{new Date(coupon.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                <ActionButton coupon={coupon}/>
            </tr>

            <Modal className={'modal-xl'} isOpen={couponDetailsModal} toggle={couponDetailsModalToggle}>
                <ModalHeader toggle={couponDetailsModalToggle} close={
                    <button className="close" onClick={couponDetailsModalToggle}>
                        &times;
                    </button>
                }>Coupon details</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        <h4 className="header-title">{coupon.code}</h4>
                        <p className="sub-header">
                            <Avatar size={95} name={coupon.code} round/>
                        </p>
                        <div className="table-responsive">
                            <table className="table mb-0">

                                <tbody>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Coupon ID</td>
                                    <td>{coupon.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Coupon Name</td>
                                    <td>{coupon.name === "" ? <NoneValue/> : coupon.name}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Coupon Code</td>
                                    <td>{coupon.code}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Products Supported</td>
                                    <td style={{ display: 'flex', alignItems: 'center', marginTop: '-0.5px', gap: '3px' }}>
                                        {coupon.eligible_products.length === 0 ? (
                                            <span>All Products</span>
                                        ) : (
                                            <>
                                            {coupon.eligible_products.slice(0, 4).map((product, index) => (
                                                <Avatar key={index} size={35} name={product} round />
                                            ))}
                                            {coupon.eligible_products.length > 4 && (
                                                <>
                                                    {expandedProductsSupported
                                                        ? coupon.eligible_products.slice(4).map((product, index) => (
                                                            <Avatar key={index} size={35} name={product} round />
                                                        ))
                                                        : null}
                                                    <span onClick={toggleExpansionProductsSupported} style={{ cursor: 'pointer' }}>
                                                <div
                                                    style={{
                                                        width: '35px',
                                                        height: '35px',
                                                        backgroundColor: 'grey',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        color: 'white',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {coupon.eligible_products.length > 4 && !expandedProductsSupported ? `+${coupon.eligible_products.length - 4}` : "-"}
                                                </div>
                                                    </span>
                                                </>
                                            )}
                                            </>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"></th>
                                    <td> Customers Supported</td>
                                    <td style={{ display: 'flex', alignItems: 'center', marginTop: '-0.5px', gap: '3px' }}>
                                        {coupon.eligible_customers.length === 0 ? (
                                            <span>All Customers</span>
                                        ) : (
                                            <>
                                                {coupon.eligible_customers.slice(0, 4).map((customer, index) => (
                                                    <Avatar key={index} size={35} name={customer} round />
                                                ))}
                                                {coupon.eligible_customers.length > 4 && (
                                                    <>
                                                        {expandedCustomersSupported
                                                            ? coupon.eligible_customers.slice(4).map((customer, index) => (
                                                                <Avatar key={index} size={35} name={customer} round />
                                                            ))
                                                            : null}
                                                        <span onClick={toggleExpansionCustomersSupported} style={{ cursor: 'pointer' }}>
                                                        <div
                                                            style={{
                                                                width: '35px',
                                                                height: '35px',
                                                                backgroundColor: 'grey',
                                                                borderRadius: '50%',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                color: 'white',
                                                                fontSize: '12px',
                                                            }}
                                                        >
                                                          {coupon.eligible_customers.length > 4 && !expandedCustomersSupported
                                                              ? `+${coupon.eligible_customers.length - 4}`
                                                              : '-'}
                                                        </div>
                                                      </span>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Coupon Value</td>
                                    <td>{coupon.value === null ? <NoneValue/> : coupon.value}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Coupon Type</td>
                                    <td>{coupon.type}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Percentage</td>
                                    <td>
                                        {coupon.percentage !== null
                                            ? `${parseFloat(coupon.percentage) % 1 === 0 ? parseInt(coupon.percentage) : coupon.percentage}%`
                                            : "-"
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Inventory Tracking Enabled</td>
                                    {/*<td>{coupon.is_inventory_tracking_enabled === null ? <NoneValue/> : coupon.stock}</td>*/}
                                    <td>{coupon.is_inventory_tracking_enabled ? "Yes" : "No"}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>Stock</td>*/}
                                {/*    <td>{coupon.stock === null ? <NoneValue/> : coupon.stock}</td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"></th>
                                    <td>Stock</td>
                                    <td>
                                        {coupon.stock !== null ? (
                                            <>
                                                {coupon.stock}
                                                <Button
                                                    onClick={stockHistoryModaltoggle}
                                                    color="#4d5bed"
                                                    className='bx-btn-primary ml-2'
                                                >
                                                    View Stock History
                                                </Button>
                                            </>
                                        ) : (
                                            <Button
                                                onClick={stockHistoryModaltoggle}
                                                color="#4d5bed"
                                                className='bx-btn-primary'
                                            >
                                                View Stock History
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Status</td>
                                    <td><Badge badge={
                                        coupon.status === "ACTIVE"
                                            ? "badge badge-light-success"
                                            : "badge badge-light-danger"
                                    } status={coupon.status}/></td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Minimum Cart Value</td>
                                    <td>{coupon.minimum_cart_value === null ? <NoneValue/> : coupon.minimum_cart_value}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Maximum Coupon Value</td>
                                    <td>{coupon.max_coupon_value === null ? <NoneValue/> : coupon.max_coupon_value}</td>
                                </tr>
                                {/*<tr>*/}
                                {/*    <th scope="row"> </th>*/}
                                {/*    <td>Expiration Date</td>*/}
                                {/*    <td>*/}
                                {/*        {coupon.expiration_date == null*/}
                                {/*            ? 'No Expiry'*/}
                                {/*            : new Date(coupon.expiration_date).toLocaleString([], DateTimeOptionsMediumShort)*/}
                                {/*        }*/}
                                {/*    </td>*/}
                                {/*</tr>*/}
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Coupon Eligible for First Order Only</td>
                                    <td>{coupon.eligible_for_first_order_only ? "Yes" : "No"}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Coupon Applicable To</td>
                                    <td>{coupon.applicable_to}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Created</td>
                                    <td>{new Date(coupon.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> </th>
                                    <td>Updated</td>
                                    <td>{new Date(coupon.updated).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            <CouponStockModal coupon={coupon} modal={stockHistoryModal} modalToggle={stockHistoryModaltoggle}/>
        </>

    );
}

export default Coupon;